import React, { useState, useEffect, useRef, useCallback } from 'react';
import PropTypes from 'prop-types';
import { ClipLoader } from 'react-spinners';
import Swal from 'sweetalert2';
import { Col, Row, Radio } from 'antd';
import { useFormik } from 'formik';
import { IoMdArrowBack, IoMdHelpCircle } from 'react-icons/io';

import history from '~/services/history';

import { useDispatch, useSelector } from 'react-redux';
import * as actions from '~/store/modules/careLines/actions';

import {
  conveniosPaciente,
  dataEHoraEntrada,
  dataEHoraSaida,
  nivelPsa,
  escoreASA,
  procedimentoCirurgico,
  tecnicaCirurgica,
  laudo,
  covidProstata,
  motivoSaida,
  complicacoesPosCirurgicas,
  linfonodos,
  paliativosETrombo,
  prontuario,
  caracteristicas,
} from './options';

import Breadcumbs from '~/components/Breadcumbs';
import ErrorField from '~/components/ErrorField';

import { LcCancerDeProstataSchema } from '~/utils/schemas/lcCancerDeProstataSchema';
import {
  numbersAndComa,
  onlyNumbers,
  scrollPageTo,
} from '~/helpers/generalFunctions';

import {
  PageTitle,
  BoxContent,
  Content,
  TitleSection,
  BoxInput,
  Label,
  BoxRadios,
  ButtonBox,
  BoxForm,
} from '../styles/style';

import DadoFaltantes from '../components/DadosFaltantes';

import { Input } from '~/components/Input';
import { RadioInput, RadioInputFlex } from '../components/RadioInput';

import { modalConfirm } from '../../LinhasDeCuidadoFormulario/dados/optionsModal';
import { toast } from 'react-toastify';
import ButtonReset from '../components/ButtonReset';
import ButtonBack from '~/components/ButtonBack';
import ExceptionsForm from '../components/ExceptionsForm';
import { getTitleIndicador } from '../careLinesInfo';

const FichadeColetaCancerDeProstata = ({ location }) => {
  const dispath = useDispatch();

  const { id } = location?.state;

  const { careLineData, loading, errorData } = useSelector(
    state => state.careLines
  );

  const firstFocus = useRef(null);
  const [numeroPaciente, setNumeroPaciente] = useState('');

  const [dados, setDados] = useState(null);

  // Limpar errors
  useEffect(() => {
    dispath(
      actions.cancerDeProstataFailure({
        errorData: null,
      })
    );
  }, []);

  useEffect(() => {
    if (location?.state?.id) {
      dispath(
        actions.cancerDeProstataGetRequest({
          id: location?.state?.id,
        })
      );
    }
  }, [location?.state]);

  useEffect(() => {
    if (id && careLineData) {
      setDados(careLineData);
    }
  }, [careLineData]);

  // Lógica de Ramificação
  useEffect(() => {
    if (dados?.cirurgia_tipo_pros == 2) {
      setExibeLinfonodos(true);
    }
    if (dados?.tipo_oms_pros == 1) {
      setExibeProntuario(true);
    }
    if (dados?.tnm_prontuario_pros == 1) {
      setExibeCaracteristicas(true);
    }
    if (dados?.tnm_prontuario_pros == 3) {
      setExibeCaracteristicas(true);
    }
  }, [dados]);

  const [exibeLinfonodos, setExibeLinfonodos] = useState(false);
  const [exibeProntuario, setExibeProntuario] = useState(false);
  const [exibeCaracteristicas, setExibeCaracteristicas] = useState(false);

  const handleExibeLinfonodos = useCallback((name, value) => {
    if (name == 'cirurgia_tipo_pros') {
      if (value == 2) {
        setExibeLinfonodos(true);
      } else {
        setExibeLinfonodos(false);
        formik.setFieldValue('linfonodos_pros', null);
      }
    }
    formik.setFieldValue(`${name}`, value);
  }, []);

  const handleExibeProntuario = useCallback((name, value) => {
    if (name == 'tipo_oms_pros') {
      if (value == 1) {
        setExibeProntuario(true);
      } else {
        setExibeProntuario(false);
        formik.setFieldValue('tnm_prontuario_pros', null);
      }
    }
    formik.setFieldValue(`${name}`, value);
  }, []);

  const handleExibeCaracteristicas = useCallback((name, value) => {
    if (name == 'tnm_prontuario_pros') {
      if (value == 1 || value == 3) {
        setExibeCaracteristicas(true);
      } else {
        setExibeCaracteristicas(false);
        formik.setFieldValue('t_pros', null);
        formik.setFieldValue('n_pros', null);
        formik.setFieldValue('m_pros', null);
      }
    }
    formik.setFieldValue(`${name}`, value);
  }, []);
  // Fim da Lógica de Ramificação

  // Reset Button
  const [isLoaded, setIsloaded] = useState(false);

  const handleResetGroup = useCallback(group => {
    group.map(item => {
      formik.setFieldValue(`${item.name}`, null);
      handleExibeLinfonodos(`${item.name}`, null);
      handleExibeProntuario(`${item.name}`, null);
      handleExibeCaracteristicas(`${item.name}`, null);
    });
  }, []);

  useEffect(() => {
    setTimeout(() => {
      setIsloaded(true);
    }, 2000);
  }, []);

  // End Reset Button

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      num_registro_pros: dados?.num_registro_pros?.toString() || null,
      dn_pros: dados?.dn_pros?.toString() || null,
      convenio_pros: dados?.convenio_pros?.toString() || null,
      entrada_data_pros: dados?.entrada_data_pros?.toString() || null,
      entrada_hora_pros: dados?.entrada_hora_pros?.toString() || null,
      psa_total_pros: dados?.psa_total_pros?.toString() || null,
      psa_livre_pros: dados?.psa_livre_pros?.toString() || null,
      gleason1_pros: dados?.gleason1_pros?.toString() || null,
      gleason2_pros: dados?.gleason2_pros?.toString() || null,
      gleason_pros: dados?.gleason_pros?.toString() || null,
      asa_pros: dados?.asa_pros?.toString() || null,
      cirurgia_tipo_pros: dados?.cirurgia_tipo_pros?.toString() || null,
      cirurgia_via_pros: dados?.cirurgia_via_pros?.toString() || null,
      tipo_oms_pros: dados?.tipo_oms_pros?.toString() || null,
      grau_gleason_pros: dados?.grau_gleason_pros?.toString() || null,
      extensao_pros: dados?.extensao_pros?.toString() || null,
      invasao_pros: dados?.invasao_pros?.toString() || null,
      status_margens_pros: dados?.status_margens_pros?.toString() || null,
      estadiamento_pros: dados?.estadiamento_pros?.toString() || null,
      linfonodos_pros: dados?.linfonodos_pros?.toString() || null,
      tnm_prontuario_pros: dados?.tnm_prontuario_pros?.toString() || null,
      t_pros: dados?.t_pros?.toString() || null,
      n_pros: dados?.n_pros?.toString() || null,
      m_pros: dados?.m_pros?.toString() || null,
      paliativos_pros: dados?.paliativos_pros?.toString() || null,
      cardio_pros: dados?.cardio_pros?.toString() || null,
      trombo_pros: dados?.trombo_pros?.toString() || null,
      transfusao_pros: dados?.transfusao_pros?.toString() || null,
      covid_prostata: dados?.covid_prostata?.toString() || null,
      saida_motivo_pros: dados?.saida_motivo_pros?.toString() || null,
      saida_data_pros: dados?.saida_data_pros?.toString() || null,
      saida_hora_pros: dados?.saida_hora_pros?.toString() || null,
    },
    validationSchema: LcCancerDeProstataSchema,

    onSubmit: async values => {
      if (id) {
        const payload = {
          ...dados,
          ...values,
        };

        // limpa erros
        dispath(
          actions.cancerDeProstataFailure({
            errorData: null,
          })
        );

        return dispath(
          actions.cancerDeProstataUpdateRequest({
            data: payload,
            id: id,
            periodo: location?.state?.periodo,
          })
        );
      }
      dispath(
        actions.cancerDeProstataRequest({
          data: values,
          periodo: location?.state?.periodo,
        })
      );
    },
  });

  const callHandleSubmit = () => {
    Swal.fire(modalConfirm).then(result => {
      if (result.value) {
        formik.handleSubmit();
      }
    });
  };

  useEffect(() => {
    scrollPageTo(75);
  }, []);

  useEffect(() => {
    const keyErrors = Object.keys(formik.errors);
    if (keyErrors.length > 0 && formik.isSubmitting) {
      setTimeout(() => {
        const errorElement = document.querySelector(`[name="${keyErrors[0]}"]`);
        if (errorElement)
          errorElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 500);
    }
  }, [formik.submitCount, formik.errors]);

  const getErrosPdf = useCallback(() => {
    const { indicador } = location.state;
    history.push({
      pathname: `/area-de-suporte`,
      state: {
        searchBy: `${getTitleIndicador(indicador)}`,
      },
    });
  }, []);

  return (
    <>
      <Breadcumbs
        path="cancer_de_prostata"
        pathTitle="Adicionar Indicadores de Linhas de Cuidado / Câncer de Próstata"
      />
      <PageTitle>
        <div>
          <ButtonBack />
          <span ref={firstFocus}>Ficha de coleta</span>
        </div>

        {errorData?.fields && isLoaded && (
          <button className="errorButton" type="button" onClick={getErrosPdf}>
            <IoMdHelpCircle size={16} color="#FFF" />
            Documentação de erros
          </button>
        )}
      </PageTitle>

      {loading ? (
        <BoxContent>
          <div className="boxSpin">
            <ClipLoader size={50} color="#74a50a" loading={loading} />
          </div>
        </BoxContent>
      ) : (
        <BoxContent>
          <div className="title">
            <h2>Preencha abaixo as informações:</h2>
          </div>

          <div className="BoxErros">
            {errorData?.fields && (
              <ExceptionsForm
                lc="cancer_de_prostata"
                exceptions={errorData?.fields}
              />
            )}
          </div>

          <Content>
            <form onSubmit={formik.handleSubmit} method="post">
              {/* Linha de Cuidado, Competência e Dados Gerais */}

              <BoxForm>
                <Row>
                  <Col span={24}>
                    <BoxInput>
                      <Col span={12} className="item">
                        <TitleSection className="font-green">
                          {'>'} Linha de Cuidado
                        </TitleSection>
                        <input
                          type="text"
                          name="indicadorNome"
                          defaultValue={location?.state?.indicadorNome || ''}
                          disabled
                        />
                      </Col>
                      <Col span={12} className="item">
                        <TitleSection className="font-green">
                          {'>'} Competência
                        </TitleSection>
                        <input
                          type="text"
                          name="periodo"
                          defaultValue={location?.state?.periodo || ''}
                          disabled
                        />
                      </Col>
                    </BoxInput>
                  </Col>
                </Row>

                <hr />

                <Row>
                  <Col span={24}>
                    <Row>
                      <TitleSection>
                        {'>'} Dados Gerais do paciente
                      </TitleSection>
                      <Col span={12} className="item">
                        <Input
                          name="num_registro_pros"
                          label="1) Número do registro"
                          type="text"
                          maxLength={5}
                          // placeholder="Número do registro"
                          value={
                            formik.values.num_registro_pros || numeroPaciente
                          }
                          hasError={
                            formik.errors.num_registro_pros &&
                            formik.touched.num_registro_pros
                              ? formik.errors.num_registro_pros
                              : ''
                          }
                          onChange={({ target }) => {
                            formik.setFieldValue(
                              'num_registro_pros',
                              onlyNumbers(target.value)
                            );
                          }}
                        />
                      </Col>

                      <Col span={12} className="item">
                        <DadoFaltantes
                          title="2) Data de nascimento"
                          name="dn_pros"
                          formik={formik}
                          hasError={
                            formik.errors.dn_pros && formik.submitCount > 0
                              ? formik.errors.dn_pros
                              : ''
                          }
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col span={24} className="item">
                        {conveniosPaciente.map(item => (
                          <RadioInputFlex
                            key={`${item.id}-${item.name}`}
                            item={item}
                            wideLabel
                            formik={formik}
                          />
                        ))}
                      </Col>
                    </Row>
                  </Col>
                </Row>

                <hr />

                <Row>
                  <Row>
                    <Col span={12}>
                      <TitleSection>{'>'} Dados da doença</TitleSection>
                    </Col>
                    <Col span={12}></Col>
                  </Row>
                  <Row>
                    <h4>
                      4{')'} Data e hora da entrada do paciente na instituição
                    </h4>
                  </Row>
                  {dataEHoraEntrada.map(item => (
                    <Col span={12} className="item" key={item.id}>
                      <DadoFaltantes
                        title={item.label}
                        name={item.name}
                        formik={formik}
                        hasError={
                          formik.errors[item.name] && formik.submitCount > 0
                            ? formik.errors[item.name]
                            : ''
                        }
                      />
                    </Col>
                  ))}
                </Row>
                {/* Situação Admissão */}
                <Row>
                  <Col span={24}>
                    <BoxInput>
                      <Row>
                        {nivelPsa.map(item => (
                          <Col span={12} className="item" key={item.id}>
                            <Input
                              name={item.name}
                              label={item.label}
                              type="text"
                              // placeholder={item.label}
                              value={formik.values[item.name]}
                              hasError={
                                formik.errors[item.name] &&
                                formik.touched[item.name]
                                  ? formik.errors[item.name]
                                  : ''
                              }
                              onChange={({ target }) => {
                                formik.setFieldValue(
                                  item.name,
                                  numbersAndComa(target.value)
                                );
                              }}
                            />
                          </Col>
                        ))}
                      </Row>
                    </BoxInput>
                  </Col>
                </Row>

                {/* Escore de Gleason */}

                <Row>
                  <Row>
                    <h4>7{')'} Escore de Gleason no diagnóstico</h4>
                  </Row>
                  <Row>
                    <Col span={8} className="item">
                      <BoxInput>
                        <Input
                          name="gleason1_pros"
                          label="Amostra 1 de Gleason no diagnóstico"
                          type="text"
                          // placeholder="Amostra 1 de Gleason no diagnóstico"
                          value={formik.values.gleason1_pros}
                          hasError={
                            formik.errors.gleason1_pros &&
                            formik.touched.gleason1_pros
                              ? formik.errors.gleason1_pros
                              : ''
                          }
                          onChange={({ target }) => {
                            formik.setFieldValue(
                              'gleason1_pros',
                              onlyNumbers(target.value)
                            );
                          }}
                        />
                        <div className="plus_mathSignal">{'+'}</div>
                      </BoxInput>
                    </Col>
                    <Col span={8} className="item">
                      <BoxInput>
                        <Input
                          name="gleason2_pros"
                          label="Amostra 2 de Gleason no diagnóstico"
                          type="text"
                          // placeholder="Amostra 2 de Gleason no diagnóstico"
                          value={formik.values.gleason2_pros}
                          hasError={
                            formik.errors.gleason2_pros &&
                            formik.touched.gleason2_pros
                              ? formik.errors.gleason2_pros
                              : ''
                          }
                          onChange={({ target }) => {
                            formik.setFieldValue(
                              'gleason2_pros',
                              onlyNumbers(target.value)
                            );
                          }}
                        />
                        <div className="mathSignal">{'='}</div>
                      </BoxInput>
                    </Col>
                    <Col span={8} className="item">
                      <BoxInput>
                        <Input
                          // style={{ marginTop: '15px' }}
                          disabled
                          name="gleason_pros"
                          label="Escore de Gleason no diagnóstico"
                          type="text"
                          // placeholder="Escore de Gleason no diagnóstico"
                          value={
                            formik.values.gleason1_pros &&
                            formik.values.gleason2_pros
                              ? Number(formik.values.gleason1_pros) +
                                Number(formik.values.gleason2_pros)
                              : ''
                          }
                        />
                      </BoxInput>
                    </Col>
                  </Row>
                </Row>

                <hr />

                <BoxForm>
                  {escoreASA.map(item => (
                    <Row>
                      <Row>
                        <Col span={20}>
                          <Label>{item.label}</Label>
                        </Col>
                        <Col span={4}>
                          {isLoaded && (
                            <ButtonReset
                              resetGroup={[...escoreASA]}
                              handleResetGroup={handleResetGroup}
                            />
                          )}
                        </Col>
                      </Row>
                      <BoxInput key={item.id}>
                        <Row>
                          {item.opcoes.map(opcao => (
                            <Col span={4} key={opcao.id}>
                              <BoxRadios
                                active={
                                  formik.values[item.name] === opcao.value
                                }
                                style={{ maxWidth: '100%' }}
                              >
                                <Radio
                                  name={item.name}
                                  value={formik.values[opcao.value]}
                                  checked={
                                    formik.values[item.name] === opcao.value
                                  }
                                  onChange={() =>
                                    formik.setFieldValue(
                                      `${item.name}`,
                                      opcao.value
                                    )
                                  }
                                >
                                  {opcao.descricao}
                                </Radio>
                              </BoxRadios>
                            </Col>
                          ))}
                        </Row>
                      </BoxInput>

                      {formik.errors[item.name] && formik.submitCount > 0 ? (
                        <ErrorField message={formik.errors[item.name]} />
                      ) : null}
                    </Row>
                  ))}
                </BoxForm>

                <BoxForm>
                  {procedimentoCirurgico.map(item => (
                    <Row>
                      <Row>
                        <Col span={12}>
                          <Label>{item.label}</Label>
                        </Col>
                        <Col span={12}>
                          {isLoaded && (
                            <ButtonReset
                              resetGroup={[...procedimentoCirurgico]}
                              handleResetGroup={handleResetGroup}
                            />
                          )}
                        </Col>
                      </Row>
                      <BoxInput key={item.id}>
                        {item.opcoes.map(opcao => (
                          <Col key={opcao.id}>
                            <BoxRadios
                              active={formik.values[item.name] === opcao.value}
                              style={{ maxWidth: '100%' }}
                            >
                              <Radio
                                name={item.name}
                                value={formik.values[opcao.value]}
                                checked={
                                  formik.values[item.name] === opcao.value
                                }
                                onChange={() =>
                                  handleExibeLinfonodos(item.name, opcao.value)
                                }
                              >
                                {opcao.descricao}
                              </Radio>
                            </BoxRadios>
                          </Col>
                        ))}
                      </BoxInput>

                      {formik.errors[item.name] && formik.submitCount > 0 ? (
                        <ErrorField message={formik.errors[item.name]} />
                      ) : null}
                    </Row>
                  ))}
                </BoxForm>

                <BoxForm>
                  {/* 
                  
                  10. Via de acesso – técnica cirúrgica
                  
                   */}

                  {tecnicaCirurgica.map(item => (
                    <Row>
                      <Row>
                        <Col span={12}>
                          <Label>{item.label}</Label>
                        </Col>
                        <Col span={12}>
                          {isLoaded && (
                            <ButtonReset
                              resetGroup={[...tecnicaCirurgica]}
                              handleResetGroup={handleResetGroup}
                            />
                          )}
                        </Col>
                      </Row>
                      <BoxInput key={item.id}>
                        {item.opcoes.map(opcao => (
                          <Col key={opcao.id}>
                            <BoxRadios
                              active={formik.values[item.name] === opcao.value}
                              style={{ maxWidth: '100%' }}
                            >
                              <Radio
                                name={item.name}
                                value={formik.values[opcao.value]}
                                checked={
                                  formik.values[item.name] === opcao.value
                                }
                                onChange={() =>
                                  formik.setFieldValue(
                                    `${item.name}`,
                                    opcao.value
                                  )
                                }
                              >
                                {opcao.descricao}
                              </Radio>
                            </BoxRadios>
                          </Col>
                        ))}
                      </BoxInput>

                      {formik.errors[item.name] && formik.submitCount > 0 ? (
                        <ErrorField message={formik.errors[item.name]} />
                      ) : null}
                    </Row>
                  ))}
                </BoxForm>

                <hr />

                <BoxForm>
                  <Row>
                    <Col span={24}>
                      <Row>
                        <Col span={12}>
                          <h4>
                            11{')'} Itens presentes no laudo anatomopatológico
                            da prostatectomia total
                          </h4>
                        </Col>
                        <Col span={12}>
                          {isLoaded && (
                            <ButtonReset
                              resetGroup={[...laudo, ...linfonodos]}
                              handleResetGroup={handleResetGroup}
                            />
                          )}
                        </Col>
                      </Row>
                      {laudo.map(item => (
                        <Col span={'12'}>
                          <Row>
                            <Label>{item.label}</Label>
                            <BoxInput key={item.id}>
                              {item.opcoes.map(opcao => (
                                <Col key={opcao.id}>
                                  <BoxRadios
                                    active={
                                      formik.values[item.name] === opcao.value
                                    }
                                    style={{ maxWidth: '100%' }}
                                  >
                                    <Radio
                                      name={item.name}
                                      value={formik.values[opcao.value]}
                                      checked={
                                        formik.values[item.name] === opcao.value
                                      }
                                      onChange={() =>
                                        handleExibeProntuario(
                                          item.name,
                                          opcao.value
                                        )
                                      }
                                    >
                                      {opcao.descricao}
                                    </Radio>
                                  </BoxRadios>
                                </Col>
                              ))}
                            </BoxInput>

                            {formik.errors[item.name] &&
                            formik.submitCount > 0 ? (
                              <ErrorField message={formik.errors[item.name]} />
                            ) : null}
                          </Row>
                        </Col>
                      ))}
                    </Col>
                  </Row>
                </BoxForm>

                {exibeLinfonodos && (
                  <BoxForm>
                    {linfonodos.map(item => (
                      <Row>
                        <Label>{item.label}</Label>
                        <BoxInput key={item.id}>
                          {item.opcoes.map(opcao => (
                            <Col key={opcao.id}>
                              <BoxRadios
                                active={
                                  formik.values[item.name] === opcao.value
                                }
                                style={{ maxWidth: '100%' }}
                              >
                                <Radio
                                  name={item.name}
                                  value={formik.values[opcao.value]}
                                  checked={
                                    formik.values[item.name] === opcao.value
                                  }
                                  onChange={() =>
                                    formik.setFieldValue(
                                      `${item.name}`,
                                      opcao.value
                                    )
                                  }
                                >
                                  {opcao.descricao}
                                </Radio>
                              </BoxRadios>
                            </Col>
                          ))}
                        </BoxInput>

                        {formik.errors[item.name] && formik.submitCount > 0 ? (
                          <ErrorField message={formik.errors[item.name]} />
                        ) : null}
                      </Row>
                    ))}
                  </BoxForm>
                )}

                {exibeProntuario && (
                  <BoxForm>
                    {prontuario.map(item => (
                      <Row>
                        <Row>
                          <Col span={12}>
                            <Label>{item.label}</Label>
                          </Col>
                          <Col span={12}>
                            {isLoaded && (
                              <ButtonReset
                                resetGroup={[...prontuario]}
                                handleResetGroup={handleResetGroup}
                              />
                            )}
                          </Col>
                        </Row>
                        <BoxInput key={item.id}>
                          {item.opcoes.map(opcao => (
                            <Col key={opcao.id}>
                              <BoxRadios
                                active={
                                  formik.values[item.name] === opcao.value
                                }
                                style={{ maxWidth: '100%' }}
                              >
                                <Radio
                                  name={item.name}
                                  value={formik.values[opcao.value]}
                                  checked={
                                    formik.values[item.name] === opcao.value
                                  }
                                  onChange={() =>
                                    handleExibeCaracteristicas(
                                      item.name,
                                      opcao.value
                                    )
                                  }
                                >
                                  {opcao.descricao}
                                </Radio>
                              </BoxRadios>
                            </Col>
                          ))}
                        </BoxInput>

                        {formik.errors[item.name] && formik.submitCount > 0 ? (
                          <ErrorField message={formik.errors[item.name]} />
                        ) : null}
                      </Row>
                    ))}
                  </BoxForm>
                )}

                {exibeCaracteristicas && (
                  <BoxForm>
                    <Row>
                      <Col span={12}>
                        <h4>
                          13{')'} Estadiamento TNM patológico (pós-operatório)
                        </h4>
                      </Col>
                      <Col span={12}>
                        {isLoaded && (
                          <ButtonReset
                            resetGroup={[...caracteristicas]}
                            handleResetGroup={handleResetGroup}
                          />
                        )}
                      </Col>
                    </Row>
                    {caracteristicas.map(item => (
                      <Row>
                        <Label>{item.label}</Label>
                        <BoxInput key={item.id}>
                          {item.opcoes.map(opcao => (
                            <Col key={opcao.id}>
                              <BoxRadios
                                active={
                                  formik.values[item.name] === opcao.value
                                }
                                style={{ maxWidth: '100%' }}
                              >
                                <Radio
                                  name={item.name}
                                  value={formik.values[opcao.value]}
                                  checked={
                                    formik.values[item.name] === opcao.value
                                  }
                                  onChange={() =>
                                    formik.setFieldValue(
                                      `${item.name}`,
                                      opcao.value
                                    )
                                  }
                                >
                                  {opcao.descricao}
                                </Radio>
                              </BoxRadios>
                            </Col>
                          ))}
                        </BoxInput>

                        {formik.errors[item.name] && formik.submitCount > 0 ? (
                          <ErrorField message={formik.errors[item.name]} />
                        ) : null}
                      </Row>
                    ))}
                  </BoxForm>
                )}

                <BoxForm>
                  <Row>
                    <Col span={24}>
                      {paliativosETrombo.map(item => (
                        <Row>
                          <Row>
                            <Col span={12}>
                              <Label>{item.label}</Label>
                            </Col>
                            <Col span={12}>
                              {isLoaded && (
                                <ButtonReset
                                  resetGroup={[...paliativosETrombo]}
                                  handleResetGroup={handleResetGroup}
                                />
                              )}
                            </Col>
                          </Row>
                          <BoxInput key={item.id}>
                            {item.opcoes.map(opcao => (
                              <Col key={opcao.id}>
                                <BoxRadios
                                  active={
                                    formik.values[item.name] === opcao.value
                                  }
                                  style={{ maxWidth: '100%' }}
                                >
                                  <Radio
                                    name={item.name}
                                    value={formik.values[opcao.value]}
                                    checked={
                                      formik.values[item.name] === opcao.value
                                    }
                                    onChange={() =>
                                      formik.setFieldValue(
                                        `${item.name}`,
                                        opcao.value
                                      )
                                    }
                                  >
                                    {opcao.descricao}
                                  </Radio>
                                </BoxRadios>
                              </Col>
                            ))}
                          </BoxInput>

                          {formik.errors[item.name] &&
                          formik.submitCount > 0 ? (
                            <ErrorField message={formik.errors[item.name]} />
                          ) : null}
                        </Row>
                      ))}
                    </Col>
                  </Row>
                </BoxForm>

                <BoxForm>
                  <Row>
                    <Col span={24}>
                      <Row>
                        <Col span={12}>
                          <h4>
                            15{')'} Complicações pós-cirúrgicas durante a
                            internação hospitalar
                          </h4>
                        </Col>
                        <Col span={12}>
                          {isLoaded && (
                            <ButtonReset
                              resetGroup={[...complicacoesPosCirurgicas]}
                              handleResetGroup={handleResetGroup}
                            />
                          )}
                        </Col>
                      </Row>
                      {complicacoesPosCirurgicas.map(item => (
                        <Row>
                          <Label>{item.label}</Label>
                          <BoxInput key={item.id}>
                            {item.opcoes.map(opcao => (
                              <Col key={opcao.id}>
                                <BoxRadios
                                  active={
                                    formik.values[item.name] === opcao.value
                                  }
                                  style={{ maxWidth: '100%' }}
                                >
                                  <Radio
                                    name={item.name}
                                    value={formik.values[opcao.value]}
                                    checked={
                                      formik.values[item.name] === opcao.value
                                    }
                                    onChange={() =>
                                      formik.setFieldValue(
                                        `${item.name}`,
                                        opcao.value
                                      )
                                    }
                                  >
                                    {opcao.descricao}
                                  </Radio>
                                </BoxRadios>
                              </Col>
                            ))}
                          </BoxInput>

                          {formik.errors[item.name] &&
                          formik.submitCount > 0 ? (
                            <ErrorField message={formik.errors[item.name]} />
                          ) : null}
                        </Row>
                      ))}
                    </Col>
                  </Row>
                </BoxForm>

                <hr />
                <BoxForm>
                  <Row>
                    <Col span={12}>
                      <TitleSection>{'>'} Dados da saída</TitleSection>
                    </Col>
                  </Row>

                  <BoxForm>
                    <Row>
                      <Col span={24}>
                        {covidProstata.map(item => (
                          <Row>
                            <Row>
                              <Col span={12}>
                                <Label>{item.label}</Label>
                              </Col>
                              <Col span={12}>
                                {isLoaded && (
                                  <ButtonReset
                                    resetGroup={[...covidProstata]}
                                    handleResetGroup={handleResetGroup}
                                  />
                                )}
                              </Col>
                            </Row>
                            <BoxInput key={item.id}>
                              {item.opcoes.map(opcao => (
                                <Col key={opcao.id}>
                                  <BoxRadios
                                    active={
                                      formik.values[item.name] === opcao.value
                                    }
                                    style={{ maxWidth: '100%' }}
                                  >
                                    <Radio
                                      name={item.name}
                                      value={formik.values[opcao.value]}
                                      checked={
                                        formik.values[item.name] === opcao.value
                                      }
                                      onChange={() =>
                                        formik.setFieldValue(
                                          `${item.name}`,
                                          opcao.value
                                        )
                                      }
                                    >
                                      {opcao.descricao}
                                    </Radio>
                                  </BoxRadios>
                                </Col>
                              ))}
                            </BoxInput>

                            {formik.errors[item.name] &&
                            formik.submitCount > 0 ? (
                              <ErrorField message={formik.errors[item.name]} />
                            ) : null}
                          </Row>
                        ))}
                      </Col>
                    </Row>
                  </BoxForm>

                  <Row>
                    <Col span={24}>
                      {motivoSaida.map(item => (
                        <Row>
                          <Row>
                            <Col span={12}>
                              <Label>{item.label}</Label>
                            </Col>
                            <Col span={12}>
                              {isLoaded && (
                                <ButtonReset
                                  resetGroup={[...motivoSaida]}
                                  handleResetGroup={handleResetGroup}
                                />
                              )}
                            </Col>
                          </Row>
                          <BoxInput key={item.id}>
                            {item.opcoes.map(opcao => (
                              <Col key={opcao.id}>
                                <BoxRadios
                                  active={
                                    formik.values[item.name] === opcao.value
                                  }
                                  style={{ maxWidth: '100%' }}
                                >
                                  <Radio
                                    name={item.name}
                                    value={formik.values[opcao.value]}
                                    checked={
                                      formik.values[item.name] === opcao.value
                                    }
                                    onChange={() =>
                                      formik.setFieldValue(
                                        `${item.name}`,
                                        opcao.value
                                      )
                                    }
                                  >
                                    {opcao.descricao}
                                  </Radio>
                                </BoxRadios>
                              </Col>
                            ))}
                          </BoxInput>

                          {formik.errors[item.name] &&
                          formik.submitCount > 0 ? (
                            <ErrorField message={formik.errors[item.name]} />
                          ) : null}
                        </Row>
                      ))}
                    </Col>
                  </Row>
                </BoxForm>

                <BoxForm>
                  <Row>
                    <h4>18) Data e hora da saída</h4>
                  </Row>
                  <Row>
                    <Col span={24}>
                      {dataEHoraSaida.map(item => (
                        <Col span={12} className="item" key={item.id}>
                          <DadoFaltantes
                            title={item.label}
                            name={item.name}
                            formik={formik}
                            hasError={
                              formik.errors[item.name] && formik.submitCount > 0
                                ? formik.errors[item.name]
                                : ''
                            }
                          />
                        </Col>
                      ))}
                    </Col>
                  </Row>
                </BoxForm>
              </BoxForm>
              <hr />

              <ButtonBox>
                <button type="button" onClick={callHandleSubmit}>
                  {loading ? 'Enviando dados...' : 'Salvar'}
                </button>
              </ButtonBox>
            </form>
          </Content>
        </BoxContent>
      )}
    </>
  );
};

FichadeColetaCancerDeProstata.propTypes = {
  location: PropTypes.shape({
    state: PropTypes.shape({
      indicador: PropTypes.string,
      indicadorNome: PropTypes.string,
      periodo: PropTypes.string,
    }),
  }).isRequired,
};

export default FichadeColetaCancerDeProstata;
